<template>
    <div>
        <div class="card">
            <div class="card-header">证书信息查询</div>
            <div class="card-body" style="min-height: 650px">

                <div class="form-group row">
                    <label for="inputFilterExpertName" class="col-3 col-form-label text-right">项目名称</label>
                    <div class="col-3">
                        <input type="text" class="form-control" id="inputFilterExpertName" placeholder="项目名称"
                               v-model="inputFilterCondition.projectName">
                    </div>
                    <div class="col-2">
                        <button class="btn btn-primary" style="width: 100%" @click="btnQuery_Click">查询</button>
                    </div>
                </div>

                <div class="alert alert-warning" v-if="certificatePageData.itemCount===0">没有获取到证书信息</div>
                <table class="table table-bordered" v-else>
                    <thead>
                    <tr>
                        <th class="text-center align-middle" style="width: 5%">序号</th>
                        <th class="text-center align-middle" style="width: 8%">姓名</th>
                        <th class="text-center align-middle" style="width: 15%">证书编号</th>
                        <th class="text-center align-middle" style="width: 10%">证书日期</th>
                        <th class="text-center align-middle" style="width: 30%">项目名称</th>
                        <template v-if="$store.state.userType === userType.COLLEGE">
                            <th class="text-center align-middle" style="width: 20%">培训基地</th>
                        </template>
                        <template v-else>
                            <th class="text-center align-middle" style="width: 20%">所属院校</th>
                        </template>

                        <th class="text-center align-middle" style="width: 20%">操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(cer, index) in certificatePageData.data">
                        <td class="text-center align-middle">{{index+1}}</td>
                        <td class="text-center align-middle">{{cer.studentName}}</td>
                        <td class="text-center align-middle">{{cer.certificateId}}</td>
                        <td class="text-center align-middle">{{cer.createDateString}}</td>
                        <td class="text-left align-middle">{{cer.projectName}}</td>
                        <template v-if="$store.state.userType === userType.COLLEGE">
                            <td class="text-left align-middle">{{cer.organName}}</td>
                        </template>
                        <template v-else>
                            <td class="text-left align-middle">{{cer.collegeName}}</td>
                        </template>
                        <td class="text-center align-middle">
                            <router-link class="btn btn-primary btn-sm mr-2" target="_blank" :to="{name: 'pdfView', params: {attFileId: cer.attFileId}}">查看</router-link>
                            <button v-if="$store.state.userType === userType.ADMIN || $store.state.userType === userType.ORGAN" class="btn btn-danger btn-sm" @click="deleteCertificate(cer.pkId)">删除</button>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <nav aria-label="..." v-if="certificatePageData.itemCount !== 0">
                    <b-pagination
                        v-model="filterCondition.page"
                        :total-rows="certificatePageData.itemCount"
                        :per-page="filterCondition.rowCountPerPage"
                        @input="page_Change"
                    />
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
import studyApi from "@/utils/api/study";
import dictionary from "@/utils/dictionary";
export default {
    name: "CertificateDataView",
    props: {
        collegeId: {type: String, required: false, default: ''},
        organId: {type: String, required: false, default: ''},
    },
    data: function () {
        return {
            userType: dictionary.userType,
            inputFilterCondition: {
                projectName: ''
            },
            filterCondition: {
                collegeId: this.collegeId,
                organId: this.organId,
                projectName: '',
                page: 1,
                rowCountPerPage: 15,
            },
            certificatePageData: {itemCount: 0},
        };
    },
    mounted() {
        this.getCertificatePageData();
    },
    methods: {
        btnQuery_Click() {
            this.filterCondition.projectName = this.inputFilterCondition.projectName
            this.filterCondition.page = 1
            this.getCertificatePageData();
        },
        getCertificatePageData() {
            studyApi.certificate.getCertificatePageData(this.filterCondition).then(res => {
               this.certificatePageData = res.data;
            });
        },
        page_Change() {
            this.getCertificatePageData();
        },
        deleteCertificate(pkId) {
            if(confirm('确认删除该学员已生成的证书？')){
                studyApi.certificate.deleteCertificate(pkId).then(res => {
                this.getCertificatePageData();
                if(res.data == 1){
                    alert("证书删除成功！")
                }else{
                    alert("证书删除失败！")
                }
            });
            }
        },
    }
}
</script>

<style scoped>

</style>